const bgImage = document.querySelector(".hero--full-width-background-image.display--mobile");
bgImage.style.height = "100vh";
bgImage.querySelector(".media").style.height = "100%";

document.querySelector("#MainContent").classList.add("page-careers");
